// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"f7a031a2","453":"0ab489a9"}[chunkId] + ".chunk.js";
};